
import {Component, Vue, Watch} from "vue-property-decorator";
import TamamlananGorevList from "@/components/lists/TamamlananGorevList.vue";
import DevamEdenGorevList from "@/components/lists/DevamEdenGorevList.vue";
import {Getter} from "vuex-class";

@Component({
  components:{DevamEdenGorevList, TamamlananGorevList}
})
export default class IslemlerView extends Vue {
  @Getter isTokenExis!: boolean;
  @Getter eicraproDurumu!: string;
  @Getter eicraproDurumMesaji!: string;
  @Getter aktifTenantId!: string | null;

  // Liste aktif kimlik varken çekilir. Eskiden mount'ta koşulsuz çekiliyordu;
  // imzacı açılır açılmaz (kimlik gelmeden) giden istek proxy'de düşüyordu. Kimlik sonradan
  // gelince (updateToken, sağlık tiki) ve BÜRO DEĞİŞİNCE (aktifTenantId) liste burada yüklenir.
  @Watch('aktifTenantId', {immediate: true})
  onKimlikDegisti(tenantId: string | null) {
    if (tenantId !== null && this.isTokenExis) {
      this.$store.dispatch('getTasksFromServer').catch(() => undefined);
    }
  }
}
